import React from 'react';
import { TextField, InputAdornment, useTheme } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import useResponsive from '../../hooks/useResponsive';

interface SearchInputBoxProps {
    searchTerm: string;
    handleSearchChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const SearchInputBox: React.FC<SearchInputBoxProps> = ({ searchTerm, handleSearchChange }) => {
    const theme = useTheme();
    const { isMobile, isTablet } = useResponsive();
    const iconColor = theme.palette.primary.main;
    return (
        <TextField
            variant="outlined"
            placeholder="Zoeken naar taak"
            value={searchTerm}
            onChange={handleSearchChange}
            fullWidth
            sx={{
                mb: isMobile ? null : 2,
                borderRadius: 6,
                borderWidth: 2,
                width: isMobile ? null : 404,
                maxWidth: isMobile ? null : 404,
                backgroundColor: theme.palette.secondary.main,
                color: theme.palette.secondary.light,
                '& .MuiOutlinedInput-notchedOutline': {
                    border: '2px solid',
                    borderColor: '#BBBBBB',
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.secondary.light,
                },
                '& .MuiOutlinedInput-root': {
                    height: isMobile ? 45 : 48,
                },
                '& .MuiInputBase-input': {
                    fontFamily: "Nunito Sans Regular500",
                    fontWeight: 500,
                    fontSize: isMobile ? 12 : (isTablet ? '16px' : '18px'),
                    lineHeight: isMobile ? '16px' : '24px',
                    color: '#2B2A5C',
                    '&::placeholder': {
                        color: '#2B2A5C',
                        opacity: 1,
                    },
                },
            }}
            slotProps={{
                input: {
                    endAdornment: (
                        <InputAdornment position="end">
                            <SearchIcon sx={{ color: iconColor, gap: '10px' }} />
                        </InputAdornment>
                    ),
                },
            }}
        />
    );
};

export default SearchInputBox;